import React, { Component } from 'react'
import $ from 'jquery'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js'

import images, { YouthFootballGrantWinners2018 } from '../../../config/images'
import '../../../dependencies/photo-swipe/photoswipe.css'
import '../../../dependencies/photo-swipe/default-skin/default-skin.css'
import '../../../stylesheets/events.css'

import YFGW2018 from './YFGW2018'
import Holiday2018 from './Holiday2018'
import First2019Meeting from './First2019Meeting'
import Board2019 from './Board2019'

class Events extends Component {
	componentDidMount() {
		var initPhotoSwipeFromDOM = function(gallerySelector) {
			// parse slide data (url, title, size ...) from DOM elements
			// (children of gallerySelector)
			var parseThumbnailElements = function(el) {
				var thumbElements = el.childNodes,
					numNodes = thumbElements.length,
					items = [],
					figureEl,
					linkEl,
					size,
					item

				for (var i = 0; i < numNodes; i++) {
					figureEl = thumbElements[i] // <figure> element

					// include only element nodes
					if (figureEl.nodeType !== 1) {
						continue
					}

					linkEl = figureEl.children[0] // <a> element
					size = linkEl.getAttribute('data-size').split('x')

					// create slide object
					item = {
						src: linkEl.getAttribute('href'),
						w: parseInt(size[0], 10),
						h: parseInt(size[1], 10),
					}

					if (figureEl.children.length > 1) {
						// <figcaption> content
						item.title = figureEl.children[1].innerHTML
					}

					if (linkEl.children.length > 0) {
						// <img> thumbnail element, retrieving thumbnail url
						item.msrc = linkEl.children[0].getAttribute('src')
					}

					item.el = figureEl // save link to element for getThumbBoundsFn
					items.push(item)
				}

				return items
			}

			// find nearest parent element
			var closest = function closest(el, fn) {
				return el && (fn(el) ? el : closest(el.parentNode, fn))
			}

			// triggers when user clicks on thumbnail
			var onThumbnailsClick = function(e) {
				e = e || window.event
				e.preventDefault ? e.preventDefault() : (e.returnValue = false)

				var eTarget = e.target || e.srcElement

				// find root element of slide
				var clickedListItem = closest(eTarget, function(el) {
					return el.tagName && el.tagName.toUpperCase() === 'FIGURE'
				})

				if (!clickedListItem) {
					return
				}

				// find index of clicked item by looping through all child nodes
				// alternatively, you may define index via data- attribute
				var clickedGallery = clickedListItem.parentNode,
					childNodes = clickedListItem.parentNode.childNodes,
					numChildNodes = childNodes.length,
					nodeIndex = 0,
					index

				for (var i = 0; i < numChildNodes; i++) {
					if (childNodes[i].nodeType !== 1) {
						continue
					}

					if (childNodes[i] === clickedListItem) {
						index = nodeIndex
						break
					}
					nodeIndex++
				}

				if (index >= 0) {
					// open PhotoSwipe if valid index found
					openPhotoSwipe(index, clickedGallery)
				}
				return false
			}

			// parse picture index and gallery index from URL (#&pid=1&gid=2)
			var photoswipeParseHash = function() {
				var hash = window.location.hash.substring(1),
					params = {}

				if (hash.length < 5) {
					return params
				}

				var vars = hash.split('&')
				for (var i = 0; i < vars.length; i++) {
					if (!vars[i]) {
						continue
					}
					var pair = vars[i].split('=')
					if (pair.length < 2) {
						continue
					}
					params[pair[0]] = pair[1]
				}

				if (params.gid) {
					params.gid = parseInt(params.gid, 10)
				}

				return params
			}

			var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
				var pswpElement = document.querySelectorAll('.pswp')[0],
					gallery,
					options,
					items

				items = parseThumbnailElements(galleryElement)

				// define options (if needed)
				options = {
					// define gallery index (for URL)
					galleryUID: galleryElement.getAttribute('data-pswp-uid'),

					getThumbBoundsFn: function(index) {
						// See Options -> getThumbBoundsFn section of documentation for more info
						var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
							pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
							rect = thumbnail.getBoundingClientRect()

						return {
							x: rect.left,
							y: rect.top + pageYScroll,
							w: rect.width,
						}
					},
				}

				// PhotoSwipe opened from URL
				if (fromURL) {
					if (options.galleryPIDs) {
						// parse real index when custom PIDs are used
						// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
						for (var j = 0; j < items.length; j++) {
							if (items[j].pid === index) {
								options.index = j
								break
							}
						}
					} else {
						// in URL indexes start from 1
						options.index = parseInt(index, 10) - 1
					}
				} else {
					options.index = parseInt(index, 10)
				}

				// exit if index not found
				if (isNaN(options.index)) {
					return
				}

				if (disableAnimation) {
					options.showAnimationDuration = 0
				}

				// Pass data to PhotoSwipe and initialize it
				gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
				gallery.init()
			}

			// loop through all gallery elements and bind events
			var galleryElements = document.querySelectorAll(gallerySelector)

			for (var i = 0, l = galleryElements.length; i < l; i++) {
				galleryElements[i].setAttribute('data-pswp-uid', i + 1)
				galleryElements[i].onclick = onThumbnailsClick
			}

			// Parse URL and open gallery if it contains #&pid=3&gid=1
			var hashData = photoswipeParseHash()
			if (hashData.pid && hashData.gid) {
				openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
			}
		}

		initPhotoSwipeFromDOM('.my-gallery')

		scrollUpdate()

		$(window).scroll(function() {
			scrollUpdate()
		})

		function scrollUpdate() {
			if ($('#EVENTS_PAGE').length) {
				//Window Variables
				var windowTop = $(window).scrollTop()
				var windowHeight = $(window).height()
				var windowBottom = windowTop + windowHeight

				//join
				var join = $('#join')
				var joinBottom = join.offset().top + join.outerHeight() * 0.75

				if (windowBottom > joinBottom) {
					join.addClass('fade-in')
				}

				//description
				var description = $('#description')
				var descriptionBottom = description.offset().top + description.outerHeight() * 0.75

				if (windowBottom > descriptionBottom) {
					description.addClass('fade-in')
				}
			}
		}
	}

	render() {
		return (
			<div id='EVENTS_PAGE'>
				{/* Content */}
				<header className='header' id='header'>
					<img
						src={images.events_header}
						alt='background'
						width='100%'
						height='100%'
						className='header-img'
					/>
					<h1 className='header-txt' id='join'>
						JOIN US
					</h1>
				</header>
				<div className='section description' id='description'>
					<h2>WHY WE DO IT</h2>
					<p>
						RPFPC events help develop and strengthen our programs, which provide youth
						with safe and proper playing equipment and support college tuition costs to
						ensure the academic and athletic success of deserving young individuals.
					</p>
				</div>
				<div className='section events'>
					<div className='event' id='golf'>
						<img
							src={images.golf_outing_background}
							alt='background'
							className='background'
						/>
						<h2>22nd Annual Celebrity Golf Outing</h2>
						<h3>Tuesday, July 14th</h3>
						<p>
							The Retired Professional Football Players of Chicago (RPFPC) and other
							Chicago sports legends invite you to the annual celebrity golf outing
							and VIP party. All proceeds will benefit our scholarship, youth grant
							and mentorship programs.
							<br />
							<a href='https://www.golfinvite.net/rpfpc' className='button'>
								REGISTER
							</a>
						</p>
					</div>
				</div>
				<div className='section events'>
					<div className='event' id='golf-outing'>
						<img
							src={images.events.firstMeetingBackground}
							alt='background'
							className='background'
						/>
						<h2>Chicago Chapter Board Member Meeting</h2>
						<h3>Thursday March 21st, 2019</h3>
						<p>
							This past week, the majority of our newly elected 'Chicago Chapter Board
							Members' were on hand downtown at Tavern on Rush for a friendly and
							informal round table gathering that included cocktails and dinner, and
							to get their new portrait pictures taken. We thought all of you might
							enjoy seeing these... 🏈💯😎
						</p>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<Board2019 />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='section events'>
					<div className='event' id='golf-outing'>
						<img
							src={images.events.firstMeetingBackground}
							alt='background'
							className='background'
						/>
						<h2>
							First NFL Players Association, Former Players - Chicago Chapter Meeting
							of 2019
						</h2>
						<h3>Thursday February 21st, 2019</h3>
						<p>
							The meeting kicked off with the usual fun filled cocktail hour followed
							by a fantastic dinner! Then, it was all about NFLPA Chapter business,
							the elections, some fun gaming that included a robust bowling
							competition, and a wonderful 'Meet & Greet' / 'Autograph & Photo Op'
							with the Punch Bowl Social Schaumburg patrons!
						</p>
						<p>
							We would like to congratulate our new leadership team beginning with
							newly elected NFLPA Chicago Chapter President, Wendell Davis who was
							unanimously voted in to lead the charge for the next four years! Brent
							Novoselsky was voted in as 1st Vice President..., Paul Ernster will
							remain as Chapter Treasurer..., and longtime member Bill Schick was
							voted in as new Chapter Secretary. Additionally, Reggie Smith will
							remain as a 2nd Vice President & Chairman of our Golf Outing..., Tom
							Serpento will remain as Executive Director and was also named as new
							Chairman for our Youth Football Grants. And finally, both Darius Fleming
							and Shafer Suggs were officially voted in as 3rd Vice Presidents.
						</p>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<First2019Meeting />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='section events'>
					<div className='event' id='golf-outing'>
						<img
							src='http://www.trophyroombar.com/wp-content/uploads/2014/11/0L7A0909.jpg'
							alt='background'
							className='background'
						/>
						<h2>Annual NFLPA / RPFPC Chicago Christmas Party</h2>
						<h3>
							Thursday December 6th, 2018
							<br />
							The Trophy Room in downtown Chicago
							<br />
							6:30 to 10:30 PM
						</h3>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<Holiday2018 />
								</div>
							</div>
						</div>
					</div>
					<div className='event'>
						<img
							src={
								YouthFootballGrantWinners2018[
									'44532953_2199901696751676_829079656228454400_o.jpg'
								]
							}
							alt='background'
							className='background'
						/>
						<h2>2018 Youth Football Grant Winners</h2>
						<p>
							On Saturday, October 13th, an elite group of our NFL Players Association
							- Chicago Chapter and RPFPC-Retired Professional Football Players of
							Chicago members were on hand for 'game day' with one of our 2018 Youth
							Football Grant Winners - the Homerstallions - at Kevin Kilmer Field in
							Homer Glen Township.They were presented with all of the Home Depot
							merchandise purchased for them by our charitable foundation totaling
							$2,000 dollars! This was in addition to the $1,500 dollar grant already
							bestowed upon them by our membership for new and safer playing
							equipment. Wilson Sporting Goods also donated some $5,000 worth of new
							TDY leather youth footballs along with premium Evoshield chinstraps that
							were divided by our three winning youth organizations this year!
						</p>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<YFGW2018 />
								</div>
							</div>
						</div>
					</div>
					<div className='event' id='holiday'>
						<img
							src={images.events.trophyRoom}
							alt='background'
							className='background'
						/>
						<h2>Annual NFLPA / RPFPC Chicago Christmas Party</h2>
						<h3>
							December 7th, 2017
							<br />
							7:00 to 11:00 PM
						</h3>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488297_1703485569726627_3609499319019598544_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488297_1703485569726627_3609499319019598544_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Ladies &amp; gentlemen... please allow us to introduce
											you to those NFLPA / RPFPC Chicago Chapter members
											present for our Holiday Party! STANDING (from L to R) -
											Brent Novoselsky, Greg Bloedorn, David Porter, Josh
											Shaw, Otis Hudson, Gemara' Williams. Bruce Herron, Tim
											Tyrrell, Ike Hill, Jarrod Johnson, Paul Ernster, Martin
											Nance, Reggie Smith and Marques Sullivan DOWN IN FRONT
											(from L to R) - Michael Wilson, Wendell Davis, Mike
											Hoban, Tom Serpento and Emery Moorehead AWESOME!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488225_1703509016390949_4292259497290054360_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488225_1703509016390949_4292259497290054360_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Pittsburgh Steeler and one of our two guest DJ's
											for the night, Oliver Gibson! Boo-yah! They rocked the
											house!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488352_1703509169724267_4583340573761654026_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488352_1703509169724267_4583340573761654026_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Reggie Smith, Brent Novoselsky, Payal Patel and Tom
											Serpento
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488462_1703509276390923_9107641513322904378_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488462_1703509276390923_9107641513322904378_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											The lovely Miss Amanda DeVries!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487329_1703509446390906_3002634440714719473_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487329_1703509446390906_3002634440714719473_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former San Francisco 49er, Josh Shaw capturing a moment!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488531_1703509669724217_8642055219930663092_o
											}
											itemProp='contentUrl'
											data-size='1149x2048'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488531_1703509669724217_8642055219930663092_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Green Bay Packer, David Porter with one of the
											many party goers!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487599_1703509856390865_5962340643052516311_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487599_1703509856390865_5962340643052516311_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Chicago Bear alumni, Ike Hill, Mike Hoban and
											Emery Moorehead with Gail Hoban
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25586789_1703510176390833_2697717958984606722_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25586789_1703510176390833_2697717958984606722_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											We love our Timmy-T! Tim Tyrrell
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25588002_1703510613057456_4144364879343107948_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25588002_1703510613057456_4144364879343107948_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25587159_1703510829724101_1000328822064732412_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25587159_1703510829724101_1000328822064732412_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Tim Tyrrell
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488351_1703510986390752_2131083935556245240_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488351_1703510986390752_2131083935556245240_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Looking good are Mrs. Marques Sullivan, the lovely
											Veronica Saldaña Sullivan and former S.F. 49er, Josh
											Shaw!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542384_1703511149724069_121072645726059668_o
											}
											itemProp='contentUrl'
											data-size='1149x2048'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542384_1703511149724069_121072645726059668_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Gail Hoban with Chapter V.P., Reggie Smith!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542387_1703511316390719_4167417550401815477_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542387_1703511316390719_4167417550401815477_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Chicago Chapter President, Brent Novoselsky with Gail
											Hoban! Nice scarf Brent!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25587213_1703511443057373_7936410502981653430_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25587213_1703511443057373_7936410502981653430_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Sharing in a laugh are Emery Moorehead, Amanda DeVries
											and Payal Patel
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25588002_1703511643057353_7461245587135763744_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25588002_1703511643057353_7461245587135763744_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Andrea Kominsky Novoselsky sharing a moment with the
											lovely Sydney Davis, daughter of Tricia Pierce Davis and
											Wendell Davis!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542624_1703511929723991_9183053680099210804_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542624_1703511929723991_9183053680099210804_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											"Big Reggie" Smith and Primus Electronics executive,
											Ryan Cuitino!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488369_1703512259723958_6018751344357213526_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488369_1703512259723958_6018751344357213526_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Andrea Kominsky Novoselsky, Sydney Davis and former
											Chicago Bear (and proud papa), Wendell Davis!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25586840_1703512449723939_4519641670928370351_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25586840_1703512449723939_4519641670928370351_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Bruce Herron and Cynthia Stafford sharing a laugh!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488210_1703512739723910_3491237446747863956_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488210_1703512739723910_3491237446747863956_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Wendell Davis, Tricia Pierce Davis, Brent Novoselsky,
											Don Grybas, Andrea Kominsky Novoselsky, Bruce Herron,
											Cynthia Stafford, Madeline Medina, Inger Britt, Tom
											Serpento and Colene Taylor.
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542572_1703512906390560_5974069251825483266_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542572_1703512906390560_5974069251825483266_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Chicago Bear, Mike Hoban getting the autographs
											out of the way early!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487228_1703513013057216_7386517107176716469_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487228_1703513013057216_7386517107176716469_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Super DJ's... former Cleveland Brown, Michael Wilson and
											former Pittsburgh Steeler, Oliver Gibson rockin' the
											house! Man, can these boys spin!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25626147_1703513193057198_8433468485224063603_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25626147_1703513193057198_8433468485224063603_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542430_1703513379723846_1577589457878250669_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542430_1703513379723846_1577589457878250669_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former San Francisco 49er, Josh Shaw and former Atlanta
											Falcon, Tim Tyrrell posing with a party guest! Too fun!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25587766_1703513549723829_8489225547972669333_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25587766_1703513549723829_8489225547972669333_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Emery Moorehead Tom Serpento
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488103_1703513769723807_6012913603314916457_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488103_1703513769723807_6012913603314916457_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Now who says this isn't a good pic?! Emery Moorehead and
											Tom Serpento sharing a smile! Lookin' good boys!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25532034_1703513913057126_8981498255888721348_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25532034_1703513913057126_8981498255888721348_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Inger Britt holding court! :)
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487631_1703514063057111_5939932220537995206_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487631_1703514063057111_5939932220537995206_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Wow! Arguably THEE best picture of the evening with the
											wonderful Davis' family - Wendell Davis, Tricia Pierce
											Davis and their beautiful daughter, Sydney! Now that's a
											Christmas Card!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542699_1703514383057079_2361279951976018390_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542699_1703514383057079_2361279951976018390_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Executive Director, Tom Serpento presenting Navy Pier's
											Payal Patel with an autographed football from the
											membership along with an NFLPA scarf! Lucky lady! — with
											Payal Patel and Tom Serpento.
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488079_1703514593057058_7526702976294068731_o
											}
											itemProp='contentUrl'
											data-size='1200x673'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488079_1703514593057058_7526702976294068731_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Carolina Panther and newly appointed NFLPA /
											RPFPC Chicago Chapter Secretary, Kinnon Tatum II with
											former RPFPC Program Assistant, Mykala Sandifer with
											some party goers! — with Christopher White.
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487452_1703514829723701_2221406157324187239_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487452_1703514829723701_2221406157324187239_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25588050_1703515129723671_5662002094222651491_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25588050_1703515129723671_5662002094222651491_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487467_1703515436390307_7960391174795403493_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487467_1703515436390307_7960391174795403493_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487186_1703515649723619_6219381313886810684_o
											}
											itemProp='contentUrl'
											data-size='1200x1800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487186_1703515649723619_6219381313886810684_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25531821_1703515863056931_413820033228893611_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25531821_1703515863056931_413820033228893611_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25487592_1703516036390247_6766579997766989731_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25487592_1703516036390247_6766579997766989731_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description' />
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25626308_1703516723056845_1703323076097705954_o
											}
											itemProp='contentUrl'
											data-size='1200x1800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25626308_1703516723056845_1703323076097705954_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Best pals for over two decades are Chicago Chapter
											President, Brent Novoselsky and Executive Director, Tom
											Serpento! Brothers for life!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488324_1703516983056819_3463088270184881341_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488324_1703516983056819_3463088270184881341_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former Minnesota Viking, Brent Novoselsky and former
											Tampa Bay Buccaneer, Reggie Smith! Our leaders!!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542643_1703517306390120_1706380912572260586_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542643_1703517306390120_1706380912572260586_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Two very lovely ladies! Jenna Ernster, wife of former
											Denver Bronco, Paul Ernster and Colene Taylor!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25587937_1703517509723433_9042516582689549398_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25587937_1703517509723433_9042516582689549398_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											With Brent Novoselsky, Madeline Medina, Tom Serpento,
											Colene Taylor and Payal Patel.
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542601_1703517973056720_3172791589175900676_o
											}
											itemProp='contentUrl'
											data-size='1200x1800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542601_1703517973056720_3172791589175900676_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											Former New England Patriot, Gemara Williams and his
											lovely wife!
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25542378_1703518536389997_8185959074263101190_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25542378_1703518536389997_8185959074263101190_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											With Madeline Medina, Colene Taylor, Inger Britt, Jenna
											Ernster, Cynthia Stafford and Andrea Kominsky
											Novoselsky.
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.rpfpc18holidayparty
													.z25488341_1703518963056621_7499572418914431089_o
											}
											itemProp='contentUrl'
											data-size='1200x800'
										>
											<img
												src={
													images.rpfpc18holidayparty
														.z25488341_1703518963056621_7499572418914431089_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											"DJ M-Dub" just doin' his thang! Michael Wilson
										</figcaption>
									</figure>
								</div>
							</div>
						</div>
					</div>
					<div className='event' id='parkinson'>
						<img
							src={
								images.ParkinsonFoundation
									.z22861482_1638425439565974_1441735651756377422_o
							}
							className='background'
							alt='background'
						/>
						<h2>Parkinson's Foundation "Moving Day Walk"</h2>
						<h3>October 15th 2017</h3>
						<p>
							On October 15th, a number of our NFLPA / RPFPC membership were happily
							present for the "Moving Day Walk" downtown at Lincoln Park with 2,500
							other Chicagoan's supporting the invaluable efforts of the Parkinson's
							Foundation! Former Chicago Bear linebacker, Bruce Herron was the "Team
							Captain" for the day. Other members included Reggie Smith (Tampa Bay
							Buccaneers), Gemara' Williams (N.E. Patriots), Tim Tyrrell (Atlanta
							Falcons), Bill Schick (K.C. Chiefs), Michael Blair (G.B. Packers), David
							Porter (G.B. Packers), Tom Hicks (Chicago Bears), Marc May (Minnesota
							Vikings), and Tom Serpento, Exec. Director, sharing the emcee duties
							with Fox 32 Chicago's Joanie Lum
						</p>
						<div className='gallery-container section'>
							<div className='gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.EAGRImages
													.z22829788_1638428612898990_593416434566992687_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22829788_1638428612898990_593416434566992687_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22829788_1638428612898990_593416434566992687_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861467_1638430552898796_9026230264363181921_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861467_1638430552898796_9026230264363181921_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861467_1638430552898796_9026230264363181921_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861482_1638425439565974_1441735651756377422_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861482_1638425439565974_1441735651756377422_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861482_1638425439565974_1441735651756377422_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861516_1638434389565079_594111357368904551_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861516_1638434389565079_594111357368904551_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861516_1638434389565079_594111357368904551_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861667_1638425206232664_2709859159218823704_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861667_1638425206232664_2709859159218823704_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861667_1638425206232664_2709859159218823704_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861667_1638432122898639_6413734200275036049_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861667_1638432122898639_6413734200275036049_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861667_1638432122898639_6413734200275036049_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861746_1638432909565227_8541173578148817599_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861746_1638432909565227_8541173578148817599_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861746_1638432909565227_8541173578148817599_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22861830_1638433482898503_979588159861682434_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22861830_1638433482898503_979588159861682434_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22861830_1638433482898503_979588159861682434_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22904565_1638434059565112_5189920314499848186_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22904565_1638434059565112_5189920314499848186_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22904565_1638434059565112_5189920314499848186_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22904586_1638429569565561_2023926200305766087_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22904586_1638429569565561_2023926200305766087_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22904586_1638429569565561_2023926200305766087_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22904910_1638431882898663_6347954105983718813_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22904910_1638431882898663_6347954105983718813_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22904910_1638431882898663_6347954105983718813_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z22904988_1638426186232566_2553101601466582828_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z22904988_1638426186232566_2553101601466582828_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22904988_1638426186232566_2553101601466582828_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23000056_1638427459565772_506673542714432514_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23000056_1638427459565772_506673542714432514_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23000056_1638427459565772_506673542714432514_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23000078_1638434632898388_2410376782712564363_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23000078_1638434632898388_2410376782712564363_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23000078_1638434632898388_2410376782712564363_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23000139_1638432532898598_3354350741990009393_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23000139_1638432532898598_3354350741990009393_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23000139_1638432532898598_3354350741990009393_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23004519_1638427856232399_6677637419811693235_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23004519_1638427856232399_6677637419811693235_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23004519_1638427856232399_6677637419811693235_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23004553_1638428146232370_1985241402256820286_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23004553_1638428146232370_1985241402256820286_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23004553_1638428146232370_1985241402256820286_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23004561_1638429052898946_6397879881270714577_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23004561_1638429052898946_6397879881270714577_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23004561_1638429052898946_6397879881270714577_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23004608_1638424739566044_3164069446785219131_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23004608_1638424739566044_3164069446785219131_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23004608_1638424739566044_3164069446785219131_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23116692_1638431116232073_2804348843799429034_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23116692_1638431116232073_2804348843799429034_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23116692_1638431116232073_2804348843799429034_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23116746_1638426969565821_544453920592817758_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23116746_1638426969565821_544453920592817758_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23116746_1638426969565821_544453920592817758_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23116894_1638433842898467_7897368544849181529_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23116894_1638433842898467_7897368544849181529_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23116894_1638433842898467_7897368544849181529_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23117016_1638423929566125_7469095476320360791_o
											}
											itemProp='contentUrl'
											data-size='1280x853'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23117016_1638423929566125_7469095476320360791_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23117016_1638423929566125_7469095476320360791_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23120202_1638429989565519_3884776797891802890_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23120202_1638429989565519_3884776797891802890_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23120202_1638429989565519_3884776797891802890_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23120327_1638424316232753_1781576732630305347_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23120327_1638424316232753_1781576732630305347_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23120327_1638424316232753_1781576732630305347_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.ParkinsonFoundation
													.z23154839_1638423612899490_5108082280029942599_o
											}
											itemProp='contentUrl'
											data-size='1280x856'
										>
											<img
												src={
													images.ParkinsonFoundation
														.z23154839_1638423612899490_5108082280029942599_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											23154839_1638423612899490_5108082280029942599_o
										</figcaption>
									</figure>
								</div>
							</div>
						</div>
					</div>
					<div className='event' id='golf'>
						<img src={images.wod} alt='background' className='background' />
						<h2>October Chapter Meeting</h2>
						<h3>October 19th Wise Owl Drinkery And Cookhouse at 7pm to 9pm</h3>
						<p>
							All members please RSVP and join us at the Wise Owl Drinkery and
							Cookhouse for a legendary AFC matchup between the Oakland Raiders and
							Kansas City Chiefs with guest speakers Jerry Fontenot (Chicago Bear
							Great), Dr. Nikki Reams (Independent Neurological Consultant), and Tom
							Finks (son of HOF Member, Jim Finks). All former players present will be
							receiving new NFLPA / RPFPC swag!
						</p>
						<div className='gallery-container section'>
							<div className='gallery' id='derby-gallery'>
								<div
									className='my-gallery'
									itemScope='itemScope'
									itemType='http://schema.org/ImageGallery'
								>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22555722_1629547617120423_7248160673412425487_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22555722_1629547617120423_7248160673412425487_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22555722_1629547617120423_7248160673412425487_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22555749_1629544243787427_2042355124576656817_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22555749_1629544243787427_2042355124576656817_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22555749_1629544243787427_2042355124576656817_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22712264_1629551840453334_8573326660556492555_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22712264_1629551840453334_8573326660556492555_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22712264_1629551840453334_8573326660556492555_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22712488_1629543533787498_7172028488074006799_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22712488_1629543533787498_7172028488074006799_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22712488_1629543533787498_7172028488074006799_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22712579_1629551000453418_1155256723585322688_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22712579_1629551000453418_1155256723585322688_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22712579_1629551000453418_1155256723585322688_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22713143_1629550690453449_584066732220936626_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22713143_1629550690453449_584066732220936626_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22713143_1629550690453449_584066732220936626_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22713270_1629543147120870_5860065517027406298_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22713270_1629543147120870_5860065517027406298_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22713270_1629543147120870_5860065517027406298_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22713566_1629549987120186_3788921165687032455_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22713566_1629549987120186_3788921165687032455_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22713566_1629549987120186_3788921165687032455_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22769668_1629546660453852_6908195912378681301_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22769668_1629546660453852_6908195912378681301_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22769668_1629546660453852_6908195912378681301_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22769834_1629547150453803_2210882702659285496_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22769834_1629547150453803_2210882702659285496_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22769834_1629547150453803_2210882702659285496_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22769889_1629542467120938_5661487666150907747_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22769889_1629542467120938_5661487666150907747_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22769889_1629542467120938_5661487666150907747_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22769969_1629551613786690_4325421188647665993_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22769969_1629551613786690_4325421188647665993_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22769969_1629551613786690_4325421188647665993_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770051_1629539363787915_5580874777198240131_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770051_1629539363787915_5580874777198240131_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770051_1629539363787915_5580874777198240131_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770053_1629539720454546_7666596906764635266_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770053_1629539720454546_7666596906764635266_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770053_1629539720454546_7666596906764635266_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770514_1629548807120304_5297564292559943317_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770514_1629548807120304_5297564292559943317_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770514_1629548807120304_5297564292559943317_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770562_1629544970454021_7637515270316657495_o
											}
											itemProp='contentUrl'
											data-size='1000x558'
										>
											<img
												src={
													images.meeting
														.z22770562_1629544970454021_7637515270316657495_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770562_1629544970454021_7637515270316657495_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770611_1629548973786954_5274603260234402741_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770611_1629548973786954_5274603260234402741_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770611_1629548973786954_5274603260234402741_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770617_1629548200453698_4609590619251632469_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770617_1629548200453698_4609590619251632469_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770617_1629548200453698_4609590619251632469_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770631_1629542047120980_4067030076592498077_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770631_1629542047120980_4067030076592498077_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770631_1629542047120980_4067030076592498077_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22770819_1629541480454370_7658714337510599546_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22770819_1629541480454370_7658714337510599546_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22770819_1629541480454370_7658714337510599546_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22791606_1629543967120788_212147007377581115_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22791606_1629543967120788_212147007377581115_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22791606_1629543967120788_212147007377581115_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22791606_1629548480453670_7759342600821590369_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22791606_1629548480453670_7759342600821590369_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22791606_1629548480453670_7759342600821590369_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22791711_1629550220453496_3009440124036422740_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22791711_1629550220453496_3009440124036422740_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22791711_1629550220453496_3009440124036422740_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22791778_1629546257120559_3127368208062346928_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22791778_1629546257120559_3127368208062346928_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22791778_1629546257120559_3127368208062346928_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22792147_1629540643787787_3674829621216631327_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22792147_1629540643787787_3674829621216631327_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22792147_1629540643787787_3674829621216631327_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22792151_1629540193787832_5083217469933605595_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22792151_1629540193787832_5083217469933605595_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22792151_1629540193787832_5083217469933605595_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22792342_1629547983787053_1714419343087681747_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22792342_1629547983787053_1714419343087681747_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22792342_1629547983787053_1714419343087681747_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22792433_1629551390453379_6274377066383415936_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22792433_1629551390453379_6274377066383415936_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22792433_1629551390453379_6274377066383415936_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22792484_1629545590453959_7801448968646844528_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22792484_1629545590453959_7801448968646844528_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22792484_1629545590453959_7801448968646844528_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22829339_1629546060453912_5474367755798310751_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22829339_1629546060453912_5474367755798310751_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22829339_1629546060453912_5474367755798310751_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22829408_1629538077121377_2105713494658658132_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22829408_1629538077121377_2105713494658658132_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22829408_1629538077121377_2105713494658658132_o
										</figcaption>
									</figure>
									<figure
										itemProp='associatedMedia'
										itemScope='itemScope'
										itemType='http://schema.org/ImageObject'
									>
										<a
											href={
												images.meeting
													.z22829741_1629546967120488_10400990566682523_o
											}
											itemProp='contentUrl'
											data-size='1000x668'
										>
											<img
												src={
													images.meeting
														.z22829741_1629546967120488_10400990566682523_o_thumb
												}
												itemProp='thumbnail'
												alt='description'
											/>
										</a>
										<figcaption itemProp='caption description'>
											22829741_1629546967120488_10400990566682523_o
										</figcaption>
									</figure>
								</div>
							</div>
						</div>
					</div>
					<div className='event' id='derby'>
						<img
							src={images.ParkinsonFoundation.RPFPC_Aurora_9}
							alt='background'
							className='background'
						/>
						<h2>RPFPC Youth Football Grant Unveiling Ceremony</h2>
						<h3>September 16th 2017</h3>
						<p>
							On Saturday - September 16th, 2017 some (14) NFLPA Chicago members along
							with our beloved partners at Home Depot converged on the city of Aurora
							for yet another RPFPC Youth Football Grant Unveiling Ceremony honoring
							another of our winners - the East Aurora Youth Tackle Football League!
							Beyond our $1,500 dollar football equipment grant, Home Depot provided
							$4,000 in merchandise to aid in the betterment of their program and
							facilities! In addition to the merchandise, Home Depot also provided
							professional artists to repaint the enormous storage containers that
							house all of their on-field equipment with some beautiful logos
							representing their league and the R.P.F.P.C.! It was certainly a day
							worth remembering where many hearts were touched and the community came
							together to support their league. The gathering was also attended by
							members of the local Aurora Police Department as they brought over a
							couple of their mobile command units to heighten the excitement! It was
							a wonderful ceremony, and we couldn't have been more proud to play a
							part in making a real difference in the lives of these youth players,
							their families and fans! Please enjoy these pictures that tell this
							story better than any words!
						</p>
						{/*<div className="gallery-container section">
		<div className="gallery" id="derby-gallery">
		  <div className="my-gallery" itemscope itemtype="http://schema.org/ImageGallery">
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-1} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-1_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description"></figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-10} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-10_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tomcat Youth Football League administrator, Mike Michalek, getting the fans pumped up!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-11} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-11_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">A slew of happy kids getting ready for the event!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-12} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-12_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tom Serpento charging up the crowd!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-13} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-13_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Home Depot's Leo Pena addressing the crowd and sharing the love!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-14} itemprop="contentUrl" data-size="1000x427"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-14_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">NFLPA Chicago members posing for a picture with the newly painted container!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-15} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-15_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">And here we go... Time to introduce our former NFL players!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-16} itemprop="contentUrl" data-size="668x1000"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-16_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Introducing former Chicago Bear and '85 Super Bowl Champion Kurt Becker!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-17} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-17_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Please give a big Chicago welcome to former Tampa Bay Buccaneer, Reggie Smith!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-18} itemprop="contentUrl" data-size="668x1000"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-18_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Ladies and gentlemen... THEE Kinnon Tatum, former Carolina Panther!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-19} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-19_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">And from the Chicago Bears, ...John Janata!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-2} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-2_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Denver Bronco, Paul Ernster enjoying the day with a Tomcat player!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-20} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-20_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">And who says that a former Iowa State Cyclone and former Univ. of Iowa Hawkeye can't share some love? Ladies and gentlemen, former Green Bay Packer David Porter!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-21} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-21_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">From the Chicago Bears, wide receiver Eric Wright!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-22} itemprop="contentUrl" data-size="668x1000"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-22_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">One of Chicago's favorite sons, from the Atlanta Falcons - Tim Tyrrell!!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-23} itemprop="contentUrl" data-size="668x1000"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-23_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Please welcome former New England Patriot, Gemara' Williams!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-24} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-24_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Kinnon Tatum sharing some inspiring words with the crowd!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-25} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-25_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Green Bay Packer David Porter sharing some love...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-26} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-26_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tomcat Youth Football league administrator and coach, Mike Michalek, receives an autographed football from the membership!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-27} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-27_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tom Serpento calling out some winners of special gifts...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-28} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-28_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">A delighted youth player wins an autographed visor by members of the '85 Super Bowl Bears!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-29} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-29_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tom Serpento reliving some glory days playing catch with Eric Wright...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-3} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-3_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Paul Ernster and Executive Director, Tom Serpento with one of the Tomcat Coaches.</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-30} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-30_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">David Porter, John Janata, Tom Serpento and Gemara' Williams!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-31} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-31_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">A picture says a thousand words, and this smile is priceless!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-32} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-32_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Gemara' making some kids beyond happy!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-33} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-33_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">These kids LOVE their heroes - their Aurora Police - as do we all!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-34} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-34_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Ready to unveil the equipment container...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-35} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-35_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Wow! So very, very cool...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-36} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-36_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Another view...</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-37} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-37_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Tom Serpento addressing the crowd and sharing the love!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-38} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-38_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Eric Wright & Tom Serpento honored to strike a pose with Aurora's finest!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-39} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-39_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Big Reggie doing what he loves most - touching a child's heart!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-4-} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-4-_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Chicago Bear, John Janata signing some autographs!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-40} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-40_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Gemara' posing with adoring fans!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-41} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-41_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description"></figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-42} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-42_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Atlanta Falcon Tim Tyrrell making a youngster's day!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-43} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-43_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">These kids love their new Wilson / Evo-Shield chin straps!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-44} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-44_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Bronco Paul Ernster touching hearts!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-45} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-45_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">What child wouldn't love an autograph from a Super Bowl winner??</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-46} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-46_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Now this young man couldn't be happier meeting his hero, former Chicago Bear Eric Wright!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-47} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-47_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Holy Moly, Batman! Let's fire up that huge brand new grill!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-48} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-48_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">We LOVE our friends from Home Depot!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-49} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-49_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Now that's some cool police hardware!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-5} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-5_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">A Tomcat player showing some High-5 skills!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-50} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-50_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Big John Janata doing what he does best - making a difference!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-51} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-51_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Gooooo Tomcats!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-6} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-6_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Some of the amazing prizes from Home Depot!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-7} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-7_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Another huge grill from Home Depot!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-8} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-8_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former '85 Super Bowl Champion, and former Chicago Bear, Kurt Becker meeting some of the Home Depot volunteers!</figcaption>
		  </figure>
			<figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
			<a href={images.ParkinsonFoundation.zRPFPC-Aurora-9} itemprop="contentUrl" data-size="1000x668"><img src={images.ParkinsonFoundation.zRPFPC-Aurora-9_thumb} itemprop="thumbnail" alt="description" /></a>
			<figcaption itemprop="caption description">Former Denver Bronco Paul Ernster, former Chicago Bear Eric Wright and Former New England Patriot Gemara' Williams all smiles with these kids!</figcaption>
		  </figure>
		  </div>
		</div>
	  </div>*/}
					</div>
				</div>
				<div className='message'>
					<h3>View more past events and leave a comment on our Facebook page.</h3>
					<a href='https://www.facebook.com/pg/rpfpchicago/photos/' className='button'>
						More Photos
					</a>
				</div>
				{/* Root element of PhotoSwipe. Must have class pswp. */}
				<div className='pswp' tabIndex={-1} role='dialog' aria-hidden='true'>
					{/* Background of PhotoSwipe.
	It's a separate element as animating opacity is faster than rgba(). */}
					<div className='pswp__bg' />
					{/* Slides wrapper with overflow:hidden. */}
					<div className='pswp__scroll-wrap'>
						{/* Container that holds slides.
			  PhotoSwipe keeps only 3 of them in the DOM to save memory.
			  Don't modify these 3 pswp__item elements, data is added later on. */}
						<div className='pswp__container'>
							<div className='pswp__item' />
							<div className='pswp__item' />
							<div className='pswp__item' />
						</div>
						{/* Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. */}
						<div className='pswp__ui pswp__ui--hidden'>
							<div className='pswp__top-bar'>
								{/* Controls are self-explanatory. Order can be changed. */}
								<div className='pswp__counter' />
								<button
									className='pswp__button pswp__button--close'
									title='Close (Esc)'
								/>
								<button
									className='pswp__button pswp__button--share'
									title='Share'
								/>
								<button
									className='pswp__button pswp__button--fs'
									title='Toggle fullscreen'
								/>
								<button
									className='pswp__button pswp__button--zoom'
									title='Zoom in/out'
								/>{' '}
								{/* Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR */}
								{/* element will get class pswp__preloader--active when preloader is running */}
								<div className='pswp__preloader'>
									<div className='pswp__preloader__icn'>
										<div className='pswp__preloader__cut'>
											<div className='pswp__preloader__donut' />
										</div>
									</div>
								</div>
							</div>
							<div className='pswp__share-modal pswp__share-modal--hidden pswp__single-tap'>
								<div className='pswp__share-tooltip' />
							</div>
							<button
								className='pswp__button pswp__button--arrow--left'
								title='Previous (arrow left)'
							/>
							<button
								className='pswp__button pswp__button--arrow--right'
								title='Next (arrow right)'
							/>
							<div className='pswp__caption'>
								<div className='pswp__caption__center' />
							</div>
						</div>
					</div>
				</div>
				{/*
	<div className="event" id="golf">
		  <img src={images.golf-outing-background} className="background">
	  <h2>19th Annual Celebrity Golf Outing and VIP Party</h2>
	  <h3>July 17th at the Bolingbrook Golf Club at 11:00 a.m.</h3>
	  <p>RPFPC and other Chicago sports legends invite you to the 19th Annual Celebrity Golf Outing and VIP Party, sponsored by PRIMUS. All event proceeds will directly benefit the RPFPC scholarship and youth grant mentorship programs.<br><a href="https://www.golfinvite.com/events/Default.aspx?pageName=rpfpc" className="button">REGISTER</a></p>

	</div>
	<div className="event" id="derby">
	  <img src={images.rpfpc_derby_photo_bw} className="background">
	  <h2>2017 Gale Sayers Foundation and RPFPC Kentucky Derby</h2>
	  <h3>May 6th 2017</h3>
	  <p>We held our Gale Sayers Foundation / RPFPC Kentucky Derby Fundraiser downtown at Quartino Ristorante on State St. It was an amazing time that benefited so many worthy causes shared by our two organizations! We couldn't have been any happier knowing that lives were touched in such a positive and worthwhile way from our coming together for a day celebrating the Derby! So sit back and enjoy the amazing photo album from our day in the sun!</p>
	  <div className="gallery-container section">
		<div className="gallery" id="derby-gallery">
		  <div className="my-gallery" itemscope itemtype="http://schema.org/ImageGallery">
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-38-Quartino-sign} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-38-Quartino-sign_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">At Quartino</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-40-Patio-view-Quartino} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-40-Patio-view-Quartino_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">At Quartino</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-42-Sayers-jersey} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-42-Sayers-jersey_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description"></figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-46-RPFPC-banner} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-46-RPFPC-banner_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description"></figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-3} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-3_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Sporting some real flare are NFLPA / RPFPC members Michael Blair, Corey Mays, Reggie Smith, Brent Novoselsky & Tom Serpento.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-12-Timmy-and-friends} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-12-Timmy-and-friends_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Former Atlanta Falcon, Tim Tyrrell with guests.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-Kentucky-Derby-6-Gale-and-Bruce} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-Kentucky-Derby-6-Gale-and-Bruce_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The legend himself, Gale Sayers with former Chicago Bear linebacker, Bruce Herron.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-1-Tom-&-Danae} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-1-Tom-&-Danae_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Tom Serpento and the lovely Danae Weidemann.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-2} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-2_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Former Denver Bronco, Paul Ernster, his father Tim, Tom Serpento, Jenna Ernster and Allison Smith.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-8-Gale-and-Ardie} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-8-Gale-and-Ardie_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Ladies and gentlemen, Gale Sayers and his amazing wife, Ardie!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-48-Guests-outside} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-48-Guests-outside_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Guests enjoying the gorgeous weather from the outdoor patio!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-22-Gaylon-and-Ted-Hendricks} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-22-Gaylon-and-Ted-Hendricks_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">GSF Executive Director (& Gale Sayer's son) Gaylon Bullard with former Oakland Raider & Hall of Fame legend Ted Hendricks!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-9-beautiful-hats-ladies} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-9-beautiful-hats-ladies_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The hats and colors worn by all were terrific!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-13-the-38th-Street-Studios-gang} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-13-the-38th-Street-Studios-gang_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">38th Street Studios CEO Ken Clay & his wife Devonn, along with Jesse Nagleberg and Mark Hoffmann.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-29-Brent-Al-and-Bruce-looking-at-phone} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-29-Brent-Al-and-Bruce-looking-at-phone_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">NFLPA / RPFPC president & former Minnesota Viking, Brent Novoselsky with former Bears Al Harris & Bruce Herron! No boys! You can't place bets with your phones!!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-45-Maddon-jersey} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-45-Maddon-jersey_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description"></figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-44-Hall-of-Fame-jerseys} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-44-Hall-of-Fame-jerseys_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">There was plenty of Hall of Fame memorabilia on hand for guests to win!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-14-a-lovely-couple-Mike-&-Anna} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-14-a-lovely-couple-Mike-&-Anna_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">A fabulous couple, Mike & Anna who volunteered!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-27-Mike-Blair-and-Anthony-Herron} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-27-Mike-Blair-and-Anthony-Herron_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Former Green Bay Packer, Michael Blair & former Detroit Lion, Anthony Herron showing some serious fashion style!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-4-Put-er-in-the-ole-vice} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-4-Put-er-in-the-ole-vice_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Michael Blair & Brent Novoselsky get a laugh as Tom Serpento says to Bruce Herron - "Put 'er in the ole vice!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-28-guests} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-28-guests_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description"></figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-49-Primus-boys-outside} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-49-Primus-boys-outside_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">A couple of the Primus boys outside & loving it!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-30-Gale-and-Brent} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-30-Gale-and-Brent_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Gale & Brent Novoselsky.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-Reg-Anthony-&-Mike-Wilson-outside} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-Reg-Anthony-&-Mike-Wilson-outside_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Former Tampa Bay Buccaneer, Reggie Smith with Anthony Herron & former Cleveland Brown, Mike Wilson. Just soaking up some rays!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-18-lucky-winners-of-ball-Joe-Skaja-and-Dorothy-Banas} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-18-lucky-winners-of-ball-Joe-Skaja-and-Dorothy-Banas_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Lucky Trivia contest winners, Dorothy Banas & her brother, Joe Skaja. Congrats!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-33-Tom-master-of-ceremonies} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-33-Tom-master-of-ceremonies_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">NFLPA / RPFPC Executive Director of PR & Master of Ceremonies, Tom Serpento just doin' his thang!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-11-Gale-&-Michael-Blair} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-11-Gale-&-Michael-Blair_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The Kansas Comet & Michael Blair!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-37-The-Primus-boys} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-37-The-Primus-boys_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">These Primus guys are everywhere!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-32-Gaylon-talking-about-the-betting} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-32-Gaylon-talking-about-the-betting_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Gaylon Bullard instructing the crowd on how to bet the ponies!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-7-Gale-and-some-lovely-ladies} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-7-Gale-and-some-lovely-ladies_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Our beloved Hall of Famer sharing some time with some beautiful gals!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-19-Tom-Danae-and-Kemmie-presenting-a-football} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-19-Tom-Danae-and-Kemmie-presenting-a-football_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Tom & Danae, along with JWC Media Social Editor - Kemmie Orquiz, present another Trivia winner with her autographed football!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-17-NFLPA-group-pic} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-17-NFLPA-group-pic_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Ya can't have a football party without a team photo! Now that's a handsome group!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-21-Gaylon-and-the-lovely-GSF-recipient} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-21-Gaylon-and-the-lovely-GSF-recipient_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Gaylon introducing the beautiful Nina Henderson, a genuine success story who benefited from the Gale Sayers After School Program!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-20-Michael-Blair-and-a-guest} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-20-Michael-Blair-and-a-guest_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description"></figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-24-Aride-Sayers-and-her-gal-pals} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-24-Aride-Sayers-and-her-gal-pals_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The gorgeous Ardie Sayers & her gal pals! Simply marvelous, darling! </figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-23-Gale-and-a-lucky-winner-of-his-jersey} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-23-Gale-and-a-lucky-winner-of-his-jersey_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">#40 is there to award his Hall of Fame jersey! Rock on!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-50-Al-Harris-and-guests} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-50-Al-Harris-and-guests_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The big man, Al Harris, striking a pose with guests! Always a gentleman, ...unless you were a QB!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-43-Brent-Tom-and-the-Primus-boys} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-43-Brent-Tom-and-the-Primus-boys_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Best pals, Brent & Tom with, ...you guessed it, the Primus guys AGAIN!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-36-lovely-lady-guests} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-36-lovely-lady-guests_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Just look at these beautiful gals setting the gold standard!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-35-Tim-Tyrrell-and-Mike-Martin} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-35-Tim-Tyrrell-and-Mike-Martin_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Making a fashion statement are former Falcon, Tim Tyrrell & former Bengal, Mike Martin!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-Gaylon-Reg-Tom-&-Kinnon} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-Gaylon-Reg-Tom-&-Kinnon_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Ladies & gentlemen, please say hello to Gaylon Bullard, Reggie Smith, Tom Serpento & former Carolina Panther, THEE Kinnon Tatum!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-34-Anthony-Herron-Paul-Tim-and-Jenna} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-34-Anthony-Herron-Paul-Tim-and-Jenna_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Anthony Herron, Paul Ernster withhis father Tim, and the gorgeous Mrs. Jenna Ernster!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-5-Brent-Al-Nora-and-Tom} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-5-Brent-Al-Nora-and-Tom_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Brent Novoselsky, Al Harris, our lovely volunteer Nora Murphy & Tom Serpento.</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-16-Tim-Tyrrell-cmon-down} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-16-Tim-Tyrrell-cmon-down_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Our fun loving little buddy, Tim Tyrrell being introduced to the audience!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-15-what-a-happy-crowd} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-15-what-a-happy-crowd_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">NFLPA / RPFPC members Corey Mays, Tim Tyrrell, Bill Schick, Tom Serpento & Bruce Herron entertaining the ladies!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-26-Brucey-cmon-down-you-lost} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-26-Brucey-cmon-down-you-lost_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Our beloved Bru-Bru (aka Bruce Herron) being introduced to the crowd! We love our Brucey Boy!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-25-Anthony-Herron-and-guests} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-25-Anthony-Herron-and-guests_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Big Ant - Anthony Herron always has time for the fans!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-31-Gale-and-Mike-Martin} itemprop="contentUrl" data-size="509x768"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-31-Gale-and-Mike-Martin_thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">The Immortal Gale Sayers with former Cincinnati Bengal, Mike Martin!</figcaption>
			  </figure>
			  <figure itemprop="associatedMedia" itemscope itemtype="http://schema.org/ImageObject">
				  <a href={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-47-Tom-Brent-and-Gaylon} itemprop="contentUrl" data-size="1200x796"><img src={images.eventImages/derby/GSF-RPFPC-Kentucky-Derby-47-Tom-Brent-and-Gaylon-thumb} itemprop="thumbnail" alt="description" />
				  </a>
				  <figcaption itemprop="caption description">Tom Serpento, Brent Novoselsky & Gaylon Bullard lookin' sharp!</figcaption>
			  </figure>
		  </div>
		</div>
	  </div>
	</div>
  </div>
  */}
			</div>
		)
	}
}

export default Events
